import { Box, IconButton, Stack, Typography } from '@mui/material'
import { CargoType } from '@planning/app/api'
import { CargoTypeIconLabel } from '@planning/components/CargoTypeIconLabel'
import { CarrierVisitStatusChip } from '@planning/components/CarrierVisitStatusChip'
import { CloseIcon, EditIcon } from '@tom-ui/ui'
import { ICarrierVisitPlanning } from '../CarrierVisitPlanning.model'

interface Props {
  visit: ICarrierVisitPlanning
  showCargoType?: boolean
  showCarrierVisitName?: boolean
  showCarrierVisitAdditionalInfo?: boolean
  onEdit?: (id: number) => void
  onClose?: () => void
}

export const CarrierVisitPlanningCardTitle = (props: Props) => {
  const { visit, showCarrierVisitName = true, showCarrierVisitAdditionalInfo = true } = props

  return (
    <Stack flexDirection='row' columnGap={2} alignItems='center' width='100% !important'>
      {showCarrierVisitName && (
        <Typography
          variant='subtitle1'
          overflow='hidden'
          whiteSpace='nowrap'
          textOverflow='ellipsis'
        >
          {visit.name}
        </Typography>
      )}
      {showCarrierVisitAdditionalInfo && <CarrierVisitPlanningCardAdditionalInfo {...props} />}
    </Stack>
  )
}

const CarrierVisitPlanningCardAdditionalInfo = ({
  visit,
  showCargoType = true,
  onEdit,
  onClose,
}: Props) => {
  const isBerthed = 'atb' in visit && !!visit.atb

  return (
    <>
      {showCargoType && (
        <CargoTypeIconLabel cargoType={visit?.cargoType ?? CargoType.Unknown} showLabel={false} />
      )}
      <Box flex='none'>
        <CarrierVisitStatusChip status={visit.status} isBerthed={isBerthed} />
      </Box>
      <Stack marginLeft={'auto'} display={'flex'} flexDirection='row' columnGap={1}>
        {onEdit && (
          <IconButton
            onClick={event => {
              event.preventDefault()
              event.stopPropagation()
              onClose?.()
              onEdit(visit.id)
            }}
          >
            <EditIcon />
          </IconButton>
        )}
        {onClose && (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </Stack>
    </>
  )
}
